import { memo } from "react";
import { generatePath, Navigate } from "react-router";

import { PATHS } from "@/routes/paths";

import { DesignMagazinePlanListPresenter } from "./presenter";
import { usePlanListQuery } from "../../model/repository/query/use-plan-list-query";

type Props = {
	hotelID: string;
};

export const DesignMagazinePlanListContainer = memo(({ hotelID }: Props) => {
	const { data } = usePlanListQuery({ hotelID });

	if (!data) {
		return <Navigate to={generatePath(PATHS.HOTEL.TOP, { hotelID })} />;
	}

	return <DesignMagazinePlanListPresenter hotelID={hotelID} serverModel={data} />;
});

DesignMagazinePlanListContainer.displayName = "DesignMagazinePlanList";
